import { gql } from '@apollo/client';

import {
  BAGGING_DISPATCH_RECORD_FIELDS,
  CHEF_FIELDS,
  COMPLAINT_FIELDS,
  COMPONENT_BATCH_FIELDS,
  DELIVERY_TICKET_FIELDS,
  DRIVER_DISPATCH_FIELDS,
  PROD_CONTROL_MEAL_FIELDS,
  FOOD_COMPONENT_FIELDS,
  FOOD_FIELDS,
  FOOD_PORTIONING_RECORD_FIELDS,
  HOURLY_DATA_UPDATE_EVENT_FIELDS,
  NOTIFICATION_STATS_FIELDS
} from './fragments';
import { withoutCostFields } from './withoutCosts';

export const SUBSCRIBE_TO_BATCH_CREATE_COMPONENT_SHORTAGE_SUBSCRIPTION = withoutCostFields(gql`
  ${FOOD_COMPONENT_FIELDS}
  subscription SubscribeToBatchCreateComponentShortage {
    subscribeToBatchCreateComponentShortage {
      ...FoodComponentFields
    }
  }
`);

export const SUBSCRIBE_TO_BATCH_UPDATE_FOODS_PORTIONING_STATUS_SUBSCRIPTION = withoutCostFields(gql`
  ${FOOD_FIELDS}
  subscription SubscribeToBatchUpdateFoodsPortioningStatus {
    subscribeToBatchUpdateFoodsPortioningStatus {
      ...FoodFields
    }
  }
`);

export const SUBSCRIBE_TO_CHEF_CHANGES_SUBSCRIPTION = gql`
  ${CHEF_FIELDS}
  subscription SubscribeToChefChanges($kitchen: Kitchen) {
    subscribeToChefChanges(kitchen: $kitchen) {
      ...ChefFields
    }
  }
`;

export const SUBSCRIBE_TO_COMPONENT_BATCH_CHANGES_SUBSCRIPTION = gql`
  ${COMPONENT_BATCH_FIELDS}
  subscription SubscribeToComponentBatchChanges($kitchen: Kitchen) {
    subscribeToComponentBatchChanges(kitchen: $kitchen) {
      ...ComponentBatchFields
    }
  }
`;

export const SUBSCRIBE_TO_DELIVERY_TICKET_CHANGES_SUBSCRIPTION = gql`
  ${DELIVERY_TICKET_FIELDS}
  subscription SubscribeToDeliveryTicketChanges($kitchen: Kitchen) {
    subscribeToDeliveryTicketChanges(kitchen: $kitchen) {
      ...DeliveryTicketFields
    }
  }
`;

export const SUBSCRIBE_TO_HOURLY_DATA_UPDATE_SUBSCRIPTION = gql`
  ${HOURLY_DATA_UPDATE_EVENT_FIELDS}
  subscription SubscribeToHourlyDataUpdate($kitchen: Kitchen) {
    subscribeToHourlyDataUpdate(kitchen: $kitchen) {
      ...HourlyDataUpdateEventFields
    }
  }
`;

export const SUBSCRIBE_TO_RESOLVE_COMPLAINT_SUBSCRIPTION = gql`
  ${COMPLAINT_FIELDS}
  subscription SubscribeToResolveComplaint($kitchen: Kitchen) {
    subscribeToResolveComplaint(kitchen: $kitchen) {
      ...ComplaintFields
    }
  }
`;

export const SUBSCRIBE_TO_UPDATE_DRIVER_DISPATCH_SUBSCRIPTION = gql`
  ${DRIVER_DISPATCH_FIELDS}
  subscription SubscribeToUpdateDriverDispatch($kitchen: Kitchen) {
    subscribeToUpdateDriverDispatch(kitchen: $kitchen) {
      ...DriverDispatchFields
    }
  }
`;

export const SUBSCRIBE_TO_UPDATE_FOOD_COMPONENT_STATUS_SUBSCRIPTION = withoutCostFields(gql`
  ${FOOD_COMPONENT_FIELDS}
  subscription SubscribeToUpdateFoodComponentStatus($kitchen: Kitchen) {
    subscribeToUpdateFoodComponentStatus(kitchen: $kitchen) {
      ...FoodComponentFields
    }
  }
`);

export const SUBSCRIBE_TO_UPDATE_FOOD_PORTIONING_SUBSCRIPTION = withoutCostFields(gql`
  ${FOOD_FIELDS}
  subscription SubscribeToUpdateFoodPortioning($kitchen: Kitchen) {
    subscribeToUpdateFoodPortioning(kitchen: $kitchen) {
      ...FoodFields
    }
  }
`);

export const SUBSCRIBE_TO_UPDATE_NOTIFICATION_STATS_SUBSCRIPTION = gql`
  ${NOTIFICATION_STATS_FIELDS}
  subscription SubscribeToUpdateNotificationStats($kitchen: Kitchen) {
    subscribeToUpdateNotificationStats(kitchen: $kitchen) {
      ...NotificationStatsFields
    }
  }
`;

export const SUBSCRIBE_TO_PROD_CONTROL_MEAL_CHANGES_SUBSCRIPTION = gql`
  ${PROD_CONTROL_MEAL_FIELDS}
  subscription SubscribeToProdControlMealChanges($kitchen: Kitchen!) {
    subscribeToProdControlMealChanges(kitchen: $kitchen) {
      ...ProdControlMealFields
    }
  }
`;

export const SUBSCRIBE_TO_FOOD_PORTIONING_RECORD_CHANGES_SUBSCRIPTION = gql`
  ${FOOD_PORTIONING_RECORD_FIELDS}
  subscription SubscribeToFoodPortioningRecordChanges($kitchen: Kitchen!, $day: String!) {
    subscribeToFoodPortioningRecordChanges(kitchen: $kitchen, day: $day) {
      ...FoodPortioningRecordFields
    }
  }
`;

export const SUBSCRIBE_TO_BAGGING_DISPATCH_RECORD_CHANGES_SUBSCRIPTION = gql`
  ${BAGGING_DISPATCH_RECORD_FIELDS}
  subscription SubscribeToBaggingDispatchRecordChanges($kitchen: Kitchen!, $day: String!) {
    subscribeToBaggingDispatchRecordChanges(kitchen: $kitchen, day: $day) {
      ...BaggingDispatchRecordFields
    }
  }
`;
